import { Card } from "@radix-ui/themes";
import { DevTriggerError } from "@/core/components/DevTriggerError";

export function ErrorHandlingContainer() {
  return (
    <Card className="fixed bottom-10 right-10 p-5 w-[18rem]">
      <DevTriggerError />
    </Card>
  );
}
